"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWordTableSchema = void 0;
const getWordTableSchema = ({ langId, }) => ({
    schemaType: "object",
    properties: [
        {
            title: "テキスト",
            propertyName: "text",
            schema: {
                schemaType: "text",
            },
        },
        ...(langId
            ? [
                {
                    title: "翻訳文",
                    propertyName: `translations.${langId}`,
                    schema: {
                        schemaType: "text",
                    },
                },
            ]
            : []),
        {
            title: "指定方法",
            propertyName: "level",
            schema: {
                schemaType: "text",
            },
        },
    ],
});
exports.getWordTableSchema = getWordTableSchema;
